import React from 'react';

const CloudServices = () => {
  return (
    <div className="page-content">
      <section className="hero-small">
        <div className="container">
          <h1>Cloud Services</h1>
          <p>Accelerate your digital transformation with scalable cloud solutions.</p>
        </div>
      </section>
      
      <section className="services-detail">
        <div className="container">
          <div className="service-grid">
            <div className="service-card">
              <h3>Cloud Migration</h3>
              <p>Seamless migration to AWS, Azure, and Google Cloud</p>
            </div>
            <div className="service-card">
              <h3>Cloud Architecture</h3>
              <p>Design and implement scalable cloud infrastructure</p>
            </div>
            <div className="service-card">
              <h3>DevOps & Automation</h3>
              <p>CI/CD pipelines and infrastructure as code</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CloudServices;